import { LocaleMessages } from "./types";

const ja: LocaleMessages = {
  // ヘッダーメニュー
  header: {
    home: 'ホーム',
    profileCV: 'プロフィール・CV',
    profileCVShort: 'プロフィール',
    publications: '出版物',
    works: '仕事'
  },
  // サブヘッダー
  subheader: {
    home: 'ホーム',
    profileCV: 'プロフィール & 履歴書 (CV)',
    publications: '出版物',
    works: '仕事',
    computerSystem2025: 'コンピュータシステム(2025)'
  },
  // フッター
  footer: {
    copyright: '© 2026 冨岡 莉生'
  },
  themeSwitch: {
    switchToGray: 'グレーテーマに切り替え',
    switchToBlue: '青テーマに切り替え',
    currentBlue: 'Blue',
    currentGray: 'Gray'
  },
  // 言語切り替えボタン
  languageSwitch: {
    switchTo: '英語に切り替え'
  },
  common: {
    loading: '読み込み中...',
    back: '戻る',
    backToWorks: '← 仕事一覧へ戻る'
  },
  // 出版物
  publications: {
    year: '出版年',
    authorship: '著者の役割',
    type: '種類',
    review: 'レビュー',
    resetFilters: 'フィルターをリセット',
    sortByType: '種類で表示',
    sortByChronological: '年で表示',
    showAbstract: '要旨を表示',
    hideAbstract: '要旨を隠す',
    abstractLabel: '要旨'
  }
};

export default ja;
